<div class="container">
  <div class="view-with-edit-option member"
       [ngClass]="{'mark-member': markMember, 'edit-mode': editMode && markMember}">
    <img  *ngIf="selectedMember.profileImg" [src]="selectedMember.profileImg" [alt]="selectedMember.name" class="home365-profile-image">
    <span *ngIf="!selectedMember.profileImg" class="home365-profile-image no-image">{{getInitials(selectedMember.name)}}</span>
    <p class="assignee-name">{{selectedMember.name}}</p>
    <i class="fa-light fa-chevron-down icons pointer" (click)="toggleEditMode()"></i>
  </div>

  <mat-form-field [style.display]="editMode ? 'block' : 'none'" class="form-width-0">
    <mat-select class="custom-mat-select" [formControl]="control" (selectionChange)="toggleEditMode()" #select
                (openedChange)="openedSelect($event)">
      <mat-option *ngFor="let member of membersList" [value]="member.id?.toLowerCase()" class="member-option">
        <div class="member-option">
          <img  *ngIf="member.profileImg" [src]="member.profileImg" [alt]="member.name" class="home365-profile-image">
          <span *ngIf="!member.profileImg" class="home365-profile-image no-image">{{getInitials(member.name)}}</span>
          <p>{{member.name}}</p>
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
